





















































































































import DeletedDocumentService from '@/services/deletedDocument/DeletedDocumentService';
import DocumentEvents from '@/views/Documents/Events.vue';
import Event from '@/datatypes/event';
import Vue from 'vue';

interface DeletedDocument {
  id: string;
  original_document_id: string;
  enterprise_id: string;
  enterprise_name: string;
  user_id: string;
  title: string;
  status: string;
  certificate_key: string | null;
  sent: string | null;
  soft_deleted_at: string;
  created: string;
  events: Event[];
}

export default Vue.extend({
  components: {
    DocumentEvents,
  },

  data: () => ({
    doc: {} as Partial<DeletedDocument>,
    errorMessage: '' as string,
    deletedDocumentService: new DeletedDocumentService(),
  }),

  computed: {
    docEvents(): Event[] {
      return this.doc.events || [];
    },
  },

  mounted() {
    this.fetchDeletedDocument();
  },

  watch: {
    $route() {
      this.fetchDeletedDocument();
    },
  },

  methods: {
    fetchDeletedDocument() {
      const { id } = this.$route.params;
      this.deletedDocumentService.getDeletedDocument(id).then((response) => {
        this.doc = response.data as DeletedDocument;
        this.errorMessage = '';
      }).catch(() => {
        this.errorMessage = 'Deleted document not found.';
      });
    },

    downloadCertificate() {
      const { id } = this.$route.params;
      this.deletedDocumentService.getDeletedDocumentCertificate(id).then((response) => {
        window.open(response.data.presigned, '_blank');
      }).catch(() => {
        this.$snackbar.message('Certificate not available for this document.');
      });
    },
  },
});
